import { render, staticRenderFns } from "./NewsCategoryPage.vue?vue&type=template&id=7c9272e4&"
import script from "./NewsCategoryPage.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryPage.vue?vue&type=script&lang=js&"
import style0 from "./NewsCategoryPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports